import React, { useEffect, useState } from 'react';
import { useProductsContext } from '../../contexts/ProductsContext';
import { Product } from '../../types';
import { useCandyRackContext } from '../../contexts/CandyRackContext';
import { ProductOfferProps } from './ProductOfferProps';

import ProductOfferItem from './ProductOfferItem';

export const CandyRackProductOffer = ({
  offer,
  parentProduct,
  handleAddToCart,
  handleRemoveFromCart,
  currentProduct,
  indexInOffers,
  offerCount,
  onClose,
  onReady,
}: ProductOfferProps & {
  parentProduct: Product;
}) => {
  const { loadProduct, resetSelectedProduct } = useProductsContext();
  const { parentProductVariantId, storefrontAccessToken } =
    useCandyRackContext();

  const [products, setProducts] = useState<Product[]>();
  useEffect(() => {
    const productInitCB = (product: Product) => {
      setProducts((prevState) => {
        if (prevState) {
          if (prevState.find((found) => found.id === product.id)) {
            return [...prevState];
          }
          return [...prevState, product];
        }

        return [product];
      });
    };

    if (offer.items.length > 0) {
      offer.items.forEach((item) => {
        loadProduct(item.item_handle).then((loadedProduct) => {
          if (loadedProduct) {
            productInitCB(loadedProduct);
          }
        });
      });
    } else if (offer.is_same_product_offer) {
      productInitCB({ ...parentProduct });
    } else if (currentProduct) {
      productInitCB(currentProduct);
    }
  }, [
    offer,
    loadProduct,
    parentProductVariantId,
    parentProduct,
    currentProduct,
  ]);

  useEffect(() => {
    if (products && onReady) {
      onReady();
    }
  }, [products, onReady]);

  if (!products) {
    return null;
  }

  return (
    <>
      {products
        // filtering undefined/empty products so that not everything breaks.
        // Currently its just for safety, theoretically this shouldn't happen
        .filter((product) => product)
        .map((product, index) => {
          return (
            <ProductOfferItem
              key={`${product.id}-${offer.id}-${index}`}
              product={product}
              offer={offer}
              resetSelectedProduct={resetSelectedProduct}
              handleAddToCart={handleAddToCart}
              handleRemoveFromCart={handleRemoveFromCart}
              indexInOffers={indexInOffers}
              offerCount={offerCount}
              parentProduct={parentProduct}
              onClose={onClose}
              storefrontAccessToken={storefrontAccessToken}
            />
          );
        })}
    </>
  );
};

export default CandyRackProductOffer;
